<template>
  <div class="CommonContentSingle-gray Crisis_upreport">
    <!-- <el-button type="primary"  @click="jump('RCWJSB')">日常危机上报</el-button>  
    <el-button type="primary"  @click="jump('ZXSSB')">咨询师上报</el-button>  
    <el-button type="primary"  @click="jump('RXSB')">热销上报</el-button> -->
    <el-container>
      <el-header style="background:rgba(255, 255, 255, 1);min-height:80px;height:auto;">
        <el-form :model="ruleForm" ref="ruleForm" :inline="true" class="demo-form-inline"
          style="margin: 0px 0px;background:rgba(255, 255, 255, 1);padding: 10px;height: 92px;">

          <el-form-item label="综合查询">
            <el-input placeholder="账号/学号/身份证号/姓名" v-model="ruleForm.Name"></el-input>
          </el-form-item>

          <el-form-item label="培训单位">
            <el-input placeholder="培训单位" v-model="ruleForm.DeptID"></el-input>
          </el-form-item>

          <el-form-item label="年级">
            <el-select v-model="ruleForm.EntryDate" placeholder="请选择年级">

              <el-option v-for="item in gradedata" :key="item.dicKey" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="学位">
            <el-select v-model="ruleForm.Degree" placeholder="请选择学位">
              <el-option label="本科生" value="本科生"></el-option>
              <el-option label="硕士研究生" value="硕士研究生"></el-option>
              <el-option label="博士研究生" value="博士研究生"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="当前危机状态">
            <el-select v-model="ruleForm.e" placeholder="请选择当前危机状态">
              <el-option label="全部" value="全部"></el-option>
              <el-option label="红色预警" value="红色预警"></el-option>
              <el-option label="橙色预警" value="橙色预警"></el-option>
              <el-option label="黄色预警" value="黄色预警"></el-option>
              <el-option label="蓝色预警" value="蓝色预警"></el-option>
              <el-option label="绿色预警" value="绿色预警"></el-option>
              <el-option label="已故同学" value="已故同学"></el-option>
            </el-select>
          </el-form-item>
          <el-button type="primary" @click="onSelect()">查询</el-button>
          <el-button type="primary" @click="resetForm()" style="margin-top: 5px;margin-left:10px">重置</el-button>
        </el-form>

      </el-header>

      <div style="background-color: #fff;">
        <el-table :data="tableData" stripe style="width: 100%;margin-top: 20px;">

          <el-table-column  label="学号">
            <template slot-scope="scope">
              {{ scope.row.UserID }}
            </template>
          </el-table-column>

          <el-table-column  prop="RealName" label="姓名">

          </el-table-column>

          <el-table-column  prop="DeptName" label="培养单位">

          </el-table-column>

          <el-table-column  prop="RealName" label="EntryDate">

          </el-table-column>

          <el-table-column  prop="Degree" label="学位">

          </el-table-column>

          <el-table-column  prop="UrgentStatus" label="当前危机状态">

          </el-table-column>

          <el-table-column  prop="ReportNum" label="危机上报次数">

          </el-table-column>

          <el-table-column  prop="IntervenNum" label="危机干预次数">

          </el-table-column>

          <el-table-column  prop="ReviewNum" label="测评报告次数">

          </el-table-column>

          <el-table-column  prop="FileNum" label="危机文档次数">

          </el-table-column>

          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" @click="Go_Review_key(scope.row)" size="small">
              心理档案
              </el-button>
            </template>
          </el-table-column>

        </el-table>
        <el-pagination style="margin-top: 20px; text-align: right" @current-change="handleCurrentChange"
          :current-page.sync="pageIndexs" :page-size="10" layout="total, prev, pager, next" :total="Count"
          v-if="Count > 0"></el-pagination>
      </div>
    </el-container>
  </div>
</template>
<script>

export default {
  data() {
    return {
      gradedata:[],
      Count: 0,
      pageIndexs: 0,
      ruleForm: {
        Name: "",
        DeptID: "",
        EntryDate: "",
        Degree: "",
        UrgentStatus: "",
        pageSize: "10",
        pageIndex: 1
      },
      form: {
        DeptName: "", RealName: "", Status: "", UserID: "", entity: "管理员", pageIndex: 1, pageSize: "10"
      },
      tableData: [],
    }
  },
  methods: {
    gourl(val) {
      let routeData = this.$router.resolve({
        path: '/visitors/ReportShow',
        query: { PaperResultID: a },
      })
      window.open(routeData.href, '_blank');
    },
    ceshigorl() {
      this.$router.push("/Crisis/Crisis_intervention?id=111");
    },

    load(form) {//列表
      this.$Http_Post('DistressPrediction/StudentArchives', {
        Name: this.ruleForm.Name, DeptID: this.ruleForm.DeptID, EntryDate: this.ruleForm.EntryDate, Degree: this.ruleForm.Degree, UrgentStatus: this.ruleForm.UrgentStatus, pageSize: this.ruleForm.pageSize, pageIndex: this.ruleForm.pageIndex,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tableData = res.Data
          this.Count = Number(res.Counts);
        }
      });
    },
    handleCurrentChange(val) {//分页点击
      this.ruleForm.pageIndex = val;
      this.load(this.form);
    },
    Go_Review_key(row) {
      localStorage.setItem('Psychological_archives', JSON.stringify(row) );
      this.$router.push({
        path: 'Psychological_archives'
      })
    },

    handle(data, node) {
    },
    resetForm() {
      this.ruleForm =  {
        Name: "",
        DeptID: "",
        EntryDate: "",
        Degree: "",
        UrgentStatus: "",
        pageSize: "10",
        pageIndex: 1
      }
      this.load(this.ruleForm);
    },

    onSelect() {
      this.ruleForm.pageIndex = 1
      this.load(this.ruleForm);
    },

    jump(val) {
      this.$router.push({ path: "/Crisis/report", query: { id: val } })
    }
  },

  mounted() {
    this.load(this.ruleForm);
    this.$Http_Post('User/GetDictionaryList', { DicTypCode: 1 }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.gradedata = res.Data
      }
    })
  }
}

</script>

<style>

.Crisis_upreport button {
  margin-bottom: 20px;
}

.Crisis_upreport .cell span {
  color: rgb(31, 52, 245);
  margin-left: 10px;
  text-align: center;
}

.el-table td,.el-table th {
  text-align: center;
}

</style>